import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { TDay, TDaysRange } from 'shared/types';
import { DateTime } from 'luxon';

export const formatWithLocale = (day: TDay, formatString: string) => {
	if (day) {
		return format(day, formatString, { locale: ru });
	}

	return '';
};

export const formatISODate = (date: TDay, isUtc: boolean = true) => {
	let timezone = 'XXX';
	if (isUtc) {
		timezone = '';
	}

	let format = formatWithLocale(date, `yyyy-MM-dd'T'HH:mm:ss${timezone}`);
	if (isUtc) {
		format += 'Z';
	}

	return format;
};

export const formatDateToDayMonthAndWeek = (day: TDay) => {
	const dayMonth = formatWithLocale(day, `dd MMMM`);
	const dayOfWeek = formatWithLocale(day, `eeeeee`);
	if (dayMonth && dayOfWeek) {
		const dayStr = dayMonth + ' ' + dayOfWeek.toUpperCase();
		return dayStr;
	}

	return '';
};

export const formatDateToDaysRangeStr = (daysRange: TDaysRange) => {
	const format = `dd MMMM yyyy`;
	const from = formatWithLocale(daysRange?.from, format);
	const to = formatWithLocale(daysRange?.to, format);

	let daysRangeStr = '';
	if (from && !to) {
		daysRangeStr = from + ' -';
	} else if (from && to) {
		daysRangeStr = from + ' - ' + to;
	}

	return daysRangeStr;
};

export const JSDateFromISO = (isoString: string) => {
	const date = DateTime.fromISO(isoString, { zone: 'utc' });
	return date.toISODate();
};

export const getDateRangeFromToday = (utc: boolean = false) => {
	const today = new Date();
	const dayAfterTomorrow = new Date();

	today.setHours(0, 0, 0, 0);
	dayAfterTomorrow.setHours(23, 59, 59, 59);

	if (utc) {
		today.setUTCDate(today.getUTCDate() + 1);
		today.setUTCHours(0, 0, 0, 0);
		dayAfterTomorrow.setUTCHours(23, 59, 59, 59);
	}

	return [today, dayAfterTomorrow];
};
